module.exports = __webpack_public_path__ + "static/img/school-8.f381080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-8.png
// module id = F2KE
// module chunks = 1